import { COMMON_PROPERTIES } from './constants';
import { NonEmptyArray, TJsonQueryKeys, TJsonQueryOptionalKeys } from '../../../../JsonQuery';
import { IJsonQuery } from '../../types/jsonQuery';

export function getUncommonProperties(
  jsonQuery: IJsonQuery,
  isRedesign: boolean,
): NonEmptyArray<TJsonQueryOptionalKeys> | null {
  const jsonQueryKeys = Object.keys(jsonQuery) as TJsonQueryKeys[];
  const uncommonProperties = jsonQueryKeys.filter(property => {
    if (isRedesign && jsonQuery._type === 'suburbansale' && ['total_area', 'site'].includes(property)) {
      return false;
    }

    return filterUncommonProperties(property);
  });

  return uncommonProperties.length > 0 ? (uncommonProperties as NonEmptyArray<TJsonQueryOptionalKeys>) : null;
}

function filterUncommonProperties(property: TJsonQueryKeys): property is TJsonQueryOptionalKeys {
  return !COMMON_PROPERTIES.includes(property);
}
